import React, { Component } from 'react'

export class Analytics extends Component {
  render() {
    return (
      <div>Analytics</div>
    )
  }
}

export default Analytics